import { parsedApplicantResumeModel } from "@/services/models/applicant";
import { objectRemoveKeys } from "@/services/utils/general";

export const parseDataWithoutId = (data) => {
  const parsedData = parsedApplicantResumeModel(data);
  return objectRemoveKeys(parsedData, ["_id", "user"]);
};
